import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, SectionHeader, RadioButton } from '../common';

export default function PaymentMethodCard({ paymentMethods, selected, onSelect }) {
  const { t } = useTranslation();
  return (
    <Card>
      <SectionHeader variant="card" title={t('common.payment_method_title')} />
      <div className="space-y-3">
        {paymentMethods.map((m) => (
          <RadioButton
            key={m.id}
            name="payment-method"
            label={m.labelKey ? t(m.labelKey) : m.label}
            value={m.id}
            checked={selected === m.id}
            onChange={() => onSelect(m.id)}
          />
        ))}
      </div>
    </Card>
  );
}
